import { Avatar } from "primereact/avatar";
import PropTypes from "prop-types";
import React from "react";

const FlaggedMessage = ({ messageInfo, formatDate }) => {
  const isFlagged = messageInfo.is_flagged;
  const getMessageHeader = () => {
    const flagStatusText = isFlagged ? "has been flagged" : "flag was removed";
    return `${messageInfo?.taskData?.name} ${flagStatusText} by ${messageInfo?.userData?.first_name} ${messageInfo?.userData?.last_name} (${role[messageInfo?.userData?.role]})`;
  };

  const role = {
    GXM_ADMIN: "GXM Admin",
    CUSTOMER: "Customer",
    LSP_USER: "Local Team",
    GXM_USER: "GXM User",
    GXM_MANAGER: "GXM Manager",
    LSP_MANAGER: "Local Team Manager",
    CUSTOMER_MANAGER: "Customer Manager",
  };

  return (
    <div className="message-container">
      <Avatar
        icon={isFlagged ? "pi pi-flag-fill" : "pi pi-flag"}
        shape="square"
        className="flagged"
      />
      <div className="message-content">
        <div className="meta-info">
          <p className="user-name">{getMessageHeader()} </p>
          <p className="date-time">{formatDate(messageInfo?.createdAt)}</p>
        </div>
        <p className="message">{messageInfo?.content}</p>
      </div>
    </div>
  );
};

FlaggedMessage.proptypes = {
  messageInfo: PropTypes.any,
  formatDate: PropTypes.func,
  status: PropTypes.string,
};

export default FlaggedMessage;
